/**
 * محاسبه قیمت و تخفیف محصول — تک‌منبع برای همه نمایش‌ها (کارت‌ها، جزئیات، ویجت‌ها).
 * درصد تخفیف در customization_data.discount_percent ذخیره می‌شود.
 */
export function priceInfo(p = {}) {
  const cd = p.customization_data || {};
  const base = Number(cd.base_price ?? p.price ?? 0) || 0;
  const pct = Math.min(99, Math.max(0, Number(cd.discount_percent ?? 0) || 0));
  const price = pct > 0 ? Math.round((base * (100 - pct)) / 100) : base;
  return { base, price, pct, hasDiscount: pct > 0 };
}

export const faNum = (n) => Number(n || 0).toLocaleString('fa-IR');
